<template>
  <div>
    <b-row class="top-row">
      <b-col class="top-col">
        <h1 class="top-h1">Build Your Target Audience</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="top-col">
        <span v-if="!isBusiness"
          ><span class="has_qp">Select a Quick Pick option below or use the tabs to more precisely define your target audience.</span><span class="without_qp" style="display: none;">Use the tabs to more precisely define your target audience.</span></span
        >
        <div v-if="isBusiness">
          <span class="has_qp">Select a Quick Pick option below or use the tabs to more precisely define your target audience.</span><span class="without_qp" style="display: none;">Use the tabs to more precisely define your target audience.</span>
        </div>
      </b-col>
    </b-row>
    <div class="m-tabs" v-if="tabs.length > 0">
      <div
        v-for="item in tabs"
        xl="2"
        lg="6"
        v-show="
          item.demoType !== 'quickPicks' ||
          (item.demoType === 'quickPicks' && exitQuickPick)
        "
        :key="item.demoType"
        class="m-tab"
        :class="{
          'm-tab-active': demoOption === item.demoType,
          'm-tab-a': tabs.length > 3,
        }"
      >
        <b-link
          v-if="item.access"
          @click="getRoute(item)"
          class="demo-tab-text"
          :class="{
            'demo-tab-text-active': demoOption === item.demoType,
            search: item.title === 'Search',
          }"
          :data-test="`demo-box-tab-${item.demoType}`"
          :style="{ 'margin-right': item.video !== '' ? '2%' : '0' }"
        >
          <icon v-if="item.title === 'Search'" name="search" />
          <span v-if="item.title !== 'Search'"> {{ item.title }}</span>
        </b-link>
      </div>
    </div>
    <b-container fluid>
      <slot></slot>
      <b-row class="demo-box save-as-quickpick" :align-h="mobileCSS">
        <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
          <span
            v-if="hasSaveQuickPick && exitQuickPick"
            id="saveAsQuickPick"
            class="m-link-go"
            @click="saveQuickPick"
            >Save as QuickPick
          </span>
          <b-tooltip
            target="saveAsQuickPick"
            custom-class="quick-pop"
            triggers="hover"
          >
            A QuickPick is a shortcut selection option you may create based on a
            bundle of selection options. If you use multiple categories to build
            an audience, you may turn that into a one-click selection option by
            creating a QuickPick. This is ideal when you frequently order new
            prospects using identical criteria.
          </b-tooltip>
        </b-col>
      </b-row>
      <b-row v-show="!isHidePhoneOption" class="demo-box" :align-h="mobileCSS">
        <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
          <h3 style="margin-bottom: 0px">Phone Option:</h3>
        </b-col>
      </b-row>
      <b-row v-show="alertDesc !== ''" class="demo-box" :align-h="mobileCSS">
        <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
          <b-alert variant="warning" v-html="alertDesc" show></b-alert>
        </b-col>
      </b-row>
      <b-row class="demo-box" :align-h="mobileCSS">
        <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
          <m-phone-option />
          <!-- <span v-if = "hasSaveQuickPick && exitQuickPick"
                  class="m-link-go"
                  @click = "saveQuickPick">Save As a QuickPick </span> -->
        </b-col>
      </b-row>
      <b-row v-show="showEmailOption" class="demo-box" :align-h="mobileCSS">
        <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
          <h4>Email Option</h4>
        </b-col>
      </b-row>
      <b-row v-show="showEmailOption" class="demo-box" :align-h="mobileCSS">
        <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
          <m-email-option />
        </b-col>
      </b-row>
      <b-row
        v-if="hasTotalRecords && datasource.hasRecordsWithPhone"
        class="demo-box"
        align-h="center"
      >
        <b-col
          align-self="center"
          xl="10"
          lg="10"
          md="10"
          sm="12"
          style="display: none"
        >
          <span class="m-link-go">
            <span
              @click="showTotalRecords"
              v-b-popover.hover="
                'See a total number of records with and without phone numbers.'
              "
              >View breakdown of records with and without phone numbers</span
            >
            <!--<span style="margin-left: 50px;"-->
            <!--v-b-popover.hover="'See a total number of records with and without phone numbers.'"-->
            <!--title="">Explain these options </span>-->
          </span>
        </b-col>
      </b-row>

      <b-row class="m-box-bottom" style="margin-top: -8px">
        <div class="bootom-btn">
          <b-btn @click="goBack">
            <icon name="arrow-left" class="btn-arrow" /> BACK
          </b-btn>
          <div class="next-box">
            <b-btn
              variant="primary"
              @click="next"
              data-test="demo-next"
              :disabled="nextDisabled"
              >NEXT STEP</b-btn
            >
            <!--<p class="next-desc">{{nextDesc}}</p>-->
          </div>
        </div>
        <span> </span>
      </b-row>
    </b-container>
  </div>
</template>
  
<script>
import MTab from "@/components/elements/MTab";
import MPhoneOption from "@/components/demo/MPhoneOption";
import MEmailOption from "@/components/demo/MEmailOption";

export default {
  components: {
    MPhoneOption,
    MTab,
    MEmailOption,
  },
  props: {
    demoOption: {
      type: String,
      default: "demo", // 'normal', 'quickPick', 'suppression', 'search', 'demo', 'interests', 'audience'
    },
    hasSaveQuickPick: {
      type: Boolean,
      default: true,
    },
    hasTotalRecords: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      alertDesc: "",
    };
  },
  created() {},
  computed: {
    isBusiness() {
      let type = this.$store.state.order.ListType;
      return [20, 90, 120, 160, 170, 180, 210, 260].indexOf(type) > -1;
    },
    showEmailOption() {
      // return this.$store.state.order.ListType === 260
      return false;
    },
    datasource() {
      return this.$store.getters["config/datasource"];
    },
    listType() {
      return this.$store.state.order.ListType;
    },
    hasPhoneOption() {
      return this.$store.getters["order/hasPhoneOption"];
    },
    hasEmailOption() {
      return this.$store.getters["order/hasEmailOption"];
    },
    hasDemo() {
      return this.$store.getters["order/hasDemo"];
    },
    tabs() {
      return this.$store.getters["config/datasource"].demoTabs;
    },
    hasGeo() {
      return this.$store.getters["order/hasGeo"];
    },
    geoItems() {
      return this.$store.getters["order/geoItems"];
    },
    currentGeoType() {
      return this.$store.getters["config/currentGeoType"];
    },
    nextDesc() {
      if (this.hasGeo) {
        return "Poll Count";
      } else {
        return "Select Area";
      }
    },
    isTargetoption() {
      return this.$store.getters["demo/isTargetoption"];
    },
    isRouteoption() {
      return this.$store.getters["demo/isRouteoption"];
    },
    exitQuickPick() {
      let demoTabs = this.$store.getters["config/datasource"].demoTabs;
      let tabHasQuickPick = false;
      for (let demo of demoTabs) {
        if (demo.demoType === "quickPicks") {
          tabHasQuickPick = true;
        }
      }
      return this.$store.state.demo.hasQuickPicks || tabHasQuickPick;
    },
    isHidePhoneOption() {
      return this.$store.getters["demo/isHidePhoneOption"];
    },
    nextDisabled() {
      if (this.$store.state.order.CurrentStep === "count") {
        return true;
      }
      if (!this.hasDemo) {
        return true;
      }
      // if (!this.hasPhoneOption) {
      //   return true
      // }
      if (this.listType === 50 && !this.isTargetoption) {
        return true;
      }
      if (this.listType === 50 && !this.isRouteoption) {
        return true;
      }
    },
    noPhoneOption() {
      return this.$store.getters["demo/noPhoneOption"];
    },
    mobileCSS () {
      return this.$store.state.config.isMobile?"center":"start"
    }
  },
  methods: {
    getRoute(item) {
      this.$router.push({ name: "demo-" + item.demoType });
    },
    saveQuickPick() {
      this.$root.$emit("bv::show::modal", "saveQuickPick");
    },
    next() {
      this.alertDesc = "";
      // check have phoneOption
      if (!this.hasDemo) {
        this.alertDesc += "Please Defined Target Audience<br>";
      }
      if (
        !this.hasPhoneOption &&
        !this.noPhoneOption &&
        !this.isHidePhoneOption
      ) {
        this.alertDesc += "Please select a Phone Option<br>";
      }
      if (this.listType === 50 && !this.isTargetoption) {
        this.alertDesc += "Please select at least one targeting option<br>";
      }
      if (this.listType === 50 && !this.isRouteoption) {
        this.alertDesc += "Please select at least one route option<br>";
      }
      if (this.alertDesc === "") {
        if (
          this.hasGeo ||
          this.$store.state.order.GeoType === 20 ||
          this.$store.state.order.GeoType === 23
        ) {
          this.$store.dispatch("order/submitOrder");
        } else {
          this.$router.push({ name: "geo" });
        }
      }
    },
    goBack() {
      window.history.go(-1)
    },
    showTotalRecords() {
      this.$root.$emit("bv::show::modal", "totalRecords");
    },
  },
  watch: {
    "$route.name"() {
      if (
        this.listType === 50 &&
        this.$route.name === "demo-demoDemographics"
      ) {
        this.$router.push("/order/50/demo/residentOccupantList");
      }
    },
  },
};
</script>
  
<style scoped lang="scss">
.box {
  padding: 16px 32px;
  justify-content: space-between;
}

.phone-option-item {
  display: inline-block;
}

.iclude-dnc-list {
  display: block;
  margin-left: 16px;
}

.next-desc {
  color: $color-border;
  font-size: 13px;
  margin-bottom: 0;
}

.next-box {
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
}

.bootom-btn {
  display: flex;
  align-items: flex-start;
}

.top-btn-box {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-top: 16px;
  padding: 0 16px;
}

.phone-row {
  margin-top: 16px;
  margin-bottom: -8px;
}

.search {
  min-width: 60px;
}

.m-tab {
  min-width: 130px;
}

@media (max-width: 1413px) {
  .m-tab-a {
    height: 72px;
  }
  .m-tab-active-a {
    height: 78px;
  }
}

@media (max-width: 769px) {
  .m-tabs {
    display: block;
  }

  .m-tab-a {
    height: 36px;
  }
  .m-tab-active-a {
    height: 42px;
  }
}
.quick-pop {
  max-width: 300px;
  font-size: 1rem;
  font-family: "Noto Sans";
  text-align: left;
}
@media (max-width: 768px) {
  .quick-pop{
    display: none;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/demo/M1DemoBox.vue